import { useUserContacts } from "../../api/queries/user/contact/useUserContacts";
import { useContactPlatforms } from "../../api/queries/enum/useContactPlatforms";
import { Card } from "primereact/card";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { ChangeEvent, SyntheticEvent, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useCreateUserContact } from "../../api/queries/user/contact/useCreateUserContact";
import { CreateUserContactPayload } from "../../api/types/user";
import { useQueryClient } from "react-query";
import { queryKeys } from "../../api/query";
import { useDeleteUserContact } from "../../api/queries/user/contact/useDeleteUserContact";

export default function UserProfile() {
  const queryClient = useQueryClient();
  const createUserContact = useCreateUserContact();
  const deleteUserContact = useDeleteUserContact();
  const { data: userContacts } = useUserContacts();
  const { data: contactPlatformOptions } = useContactPlatforms();

  const [contactPlatform, setContactPlatform] = useState<string>("");
  const onContactPlatformChange = (event: DropdownChangeEvent) =>
    setContactPlatform(event.value);

  const [contactValue, setContactValue] = useState<string>("");
  const onContactValueChange = (event: ChangeEvent<HTMLInputElement>) =>
    setContactValue(event.target.value);

  const onNewContactSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    const payload: CreateUserContactPayload = {
      contacts: [
        {
          type_id: contactPlatform,
          value: contactValue,
        },
      ],
    };

    await createUserContact.mutateAsync(payload);

    queryClient.invalidateQueries(queryKeys.userContacts());

    setContactPlatform("");
    setContactValue("");
  };

  const onContactDelete = async (id: string) => {
    await deleteUserContact.mutateAsync(id);
    queryClient.invalidateQueries(queryKeys.userContacts());
  };

  return (
    <div className="col-12 md:col-4">
      <Card title="My contacts">
        {userContacts?.data.results.length === 0 && <i>No contacts</i>}

        {userContacts?.data.results.map((contact) => (
          <div key={contact.id} className="flex align-items-center">
            <div className="flex-1">
              {contact.contact_platform.name} - {contact.contact_value}
            </div>

            <Button
              type="button"
              icon={"pi pi-times"}
              iconPos="right"
              className="p-button-sm p-button-text p-button-danger"
              onClick={() => onContactDelete(contact.id)}
            />
          </div>
        ))}

        <hr />

        <form onSubmit={onNewContactSubmit}>
          <div className="p-fluid">
            <div className="field">
              <label>Type:</label>
              <Dropdown
                options={contactPlatformOptions?.data.results || []}
                value={contactPlatform}
                onChange={onContactPlatformChange}
                optionValue="id"
                optionLabel="name"
                required={true}
              />
            </div>

            <div className="field">
              <label>Value:</label>
              <InputText
                value={contactValue}
                onChange={onContactValueChange}
                required={true}
              />
            </div>
          </div>

          <Button
            label="Add new contact"
            icon="pi pi-plus"
            className="p-button-sm"
          />
        </form>
      </Card>
    </div>
  );
}
